<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
          <graph-tool-bar :showSource="false" :dateRangeMenu="false" @on-selected="onPanelSelect">
            <template slot="appliancesMenu">
              <meters-test-menu @on-selected="onSelectedMeter"></meters-test-menu>
            </template>
          </graph-tool-bar>
        </md-card-header>

        <md-card-content v-if="tabNames.length">
          <div class="modal-footer">
            <md-button
              class="md-warning"
              @click.native="downloadTests"
              :disabled="!getStatus()"
            >Sync data</md-button>
          </div>

          <tabs :tab-name="tabNames" flex-column plain color-button="success" style="margin: 0px;">
            <h4 class="title" slot="header-title">Database meter tests</h4>

            <!-- here you can add your content for tab-content -->
            <template v-for="(content, tabIndex) in tabContents" :slot="'tab-pane-'+(tabIndex + 1)">
              <div class="md-layout">
                <div class="md-layout-item md-size-70 mx-auto">
                  Test #{{tabIndex + 1}}
                  <md-table>
                    <md-table-row v-for="obj in tabObjects" :key="obj">
                      <md-table-cell>{{obj}}</md-table-cell>
                      <md-table-cell>{{content[obj] ? content[obj] : "-"}}</md-table-cell>
                    </md-table-row>
                  </md-table>
                </div>
              </div>
            </template>
          </tabs>
        </md-card-content>
      </md-card>
    </div>

    <div class="md-layout-item" v-if="!tabNames.length">
      <md-empty-state
        md-icon="filter_none"
        md-label="Any stored meters test"
        md-description="No stored meters test in database"
      >
        <md-button
          class="md-warning"
          @click.native="downloadTests"
          :disabled="!getStatus()"
        >Start sync data</md-button>
      </md-empty-state>
    </div>

    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>


<script>
import graphToolBar from "@/components/GraphToolBar";
import MetersTestMenu from "./MetersTestMenu";
import { getSelectedDeviceToken } from "@/storage/memoryStorage";
import snackBar from "@/components/SnackBar";
import TabsOriginal from "@/components/TabsOriginal";

import axios from "axios";
import Swal from "sweetalert2";

export default {
  components: {
    Tabs: TabsOriginal,
    graphToolBar,
    snackBar,
    MetersTestMenu
  },

  data() {
    return {
      selectedDevice: {
        device: {}
      },
      tabNames: [],
      tabContents: [],
      tabObjects: []
    };
  },

  computed: {
    deviceList() {
      return this.$store.getters.getDeviceList;
    }
  },

  methods: {
    onPanelSelect(data) {
      this.selectedDevice = data;
    },

    onSelectedMeter(meter) {
      if (this.selectedDevice && meter.ID_meter != 0) {
        this.getTestResults(meter.ID_meter);
      } else {
        this.tabNames = [];
        this.tabContents = [];
        this.tabObjects = [];
      }
    },

    getStatus() {
      try {
        const findDevice = this.deviceList[this.deviceList.findIndex(e => e.mac == this.selectedDevice.device.mac)];
        
        if (findDevice.status == "ONLINE" && findDevice.connection == "BT_MQTT") {
          return 1;
        } else {
          return 0;
        }
      } catch (err) {
        return 0;
      }
    },

    getTestResults(ID_meter) {
      this.$store.commit("setLoading", true);
      this.tabNames = [];
      this.tabContents = [];
      this.tabObjects = [];

      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_R + "/applied-precision/test-result",
        data: {
          device_token: getSelectedDeviceToken(this.selectedDevice.device.mac),
          ID_meter: Number(ID_meter)
        },
        withCredentials: true
      })
        .then(response => {
          response.data.data.forEach(el => {
            this.tabNames.push(el.ERROR.toFixed(2) + "%");
            this.tabContents.push(el);
          });

          delete this.tabContents[0].ID_meter;
          this.tabObjects = Object.keys(this.tabContents[0]);
          this.$store.commit("setLoading", false);
        })
        .catch(error => {
          this.$store.commit("setLoading", false);
          if (error.response) {
            if (error.response.data.code !== 610) {
              this.$refs.snackbar.notify(
                this.$lang.messages.api_communication_error
              );
            }
          }
        });
    },

    downloadTests() {
      Swal.queue([
        {
          title: this.$lang.general.are_you_sure,
          text: "Lokálna databáza bude nahradená databázov zariadenia",
          type: "warning",
          showCancelButton: true,
          cancelButtonClass: "md-button md-danger",
          cancelButtonText: this.$lang.keys.cancel,
          confirmButtonClass: "md-button md-success",
          confirmButtonText: this.$lang.keys.yes,
          buttonsStyling: false,
          showLoaderOnConfirm: true,

          preConfirm: () => {
            Swal.insertQueueStep({
              title: "Downloading...",
              text: "Please wait",
              showConfirmButton: false,
              allowOutsideClick: false,
              allowEscapeKey: false
            });

            axios({
              method: "POST",
              url:
                this.$ENDPOINTS.API_W + "/applied-precision/download-database",
              data: {
                device_token: getSelectedDeviceToken(
                  this.selectedDevice.device.mac
                ),
                meters: true
              },
              withCredentials: true
            })
              .then(response => {
                Swal.fire({
                  title: this.$lang.messages.success,
                  text: "Successfully downloaded database",
                  type: "success",
                  confirmButtonClass: "md-button md-success",
                  confirmButtonText: this.$lang.keys.close,
                  buttonsStyling: false,
                  timer: 2000
                }).then(() => {
                  this.$router.go();
                })
              })
              .catch(error => {
                //Swal.close();
                Swal.fire({
                  title: this.$lang.messages.error,
                  text: this.$lang.messages.api_communication_error,
                  type: "error",
                  confirmButtonClass: "md-button md-warning",
                  confirmButtonText: this.$lang.keys.close,
                  buttonsStyling: false
                });
              });
          }
        }
      ]);
    }
  }
};
</script>


<style lang="scss" scoped>
.md-layout {
  margin-top: -29px;
}

.modal-footer {
  padding: 8px 24px 0px 24px;
}
</style>
